import { FetchPerformance } from "api";
import { StudentIDState } from "global-states";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { PerformancePayload } from "./types";

export default function usePerformance() {
  const studentID = useRecoilValue(StudentIDState);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState<PerformancePayload | undefined>(undefined);
  const [error, setError] = useState<undefined | string>(undefined);
  useEffect(() => {
    if (!studentID || studentID === "") return;
    setIsLoading(true);
    FetchPerformance(studentID)
      .then((res) => {
        setError(undefined);
        setData(transformData(res.data));
      })
      .catch((err) => setError(JSON.stringify(err)))
      .finally(() => setIsLoading(false));
  }, [studentID]);
  return { data, error, isLoading };
}

function transformData(data: PerformancePayload): PerformancePayload {
  return {
    data: {
      pred: {
        class: {
          最高: transformNegativeValueToNaN(data.data.pred.class.最高),
          最低: transformNegativeValueToNaN(data.data.pred.class.最低),
          中位數: transformNegativeValueToNaN(data.data.pred.class.中位數),
          平均: transformNegativeValueToNaN(data.data.pred.class.平均),
          下四分位: transformNegativeValueToNaN(
            data.data.pred.class["下四分位"]
          ),
          上四分位: transformNegativeValueToNaN(
            data.data.pred.class["上四分位"]
          ),
          學生: transformNegativeValueToNaN(data.data.pred.class.學生),
        },
        school: {
          最高: transformNegativeValueToNaN(data.data.pred.school.最高),
          最低: transformNegativeValueToNaN(data.data.pred.school.最低),
          中位數: transformNegativeValueToNaN(data.data.pred.school.中位數),
          平均: transformNegativeValueToNaN(data.data.pred.school.平均),
          下四分位: transformNegativeValueToNaN(
            data.data.pred.school["下四分位"]
          ),
          上四分位: transformNegativeValueToNaN(
            data.data.pred.school["上四分位"]
          ),
          學生: transformNegativeValueToNaN(data.data.pred.school.學生),
        },
      },
      results: {
        class: {
          最高: transformNegativeValueToNaN(data.data.results.class.最高),
          最低: transformNegativeValueToNaN(data.data.results.class.最低),
          中位數: transformNegativeValueToNaN(data.data.results.class.中位數),
          平均: transformNegativeValueToNaN(data.data.results.class.平均),
          下四分位: transformNegativeValueToNaN(
            data.data.results.class["下四分位"]
          ),
          上四分位: transformNegativeValueToNaN(
            data.data.results.class["上四分位"]
          ),
          學生: transformNegativeValueToNaN(data.data.results.class.學生),
        },
        school: {
          最高: transformNegativeValueToNaN(data.data.results.school.最高),
          最低: transformNegativeValueToNaN(data.data.results.school.最低),
          中位數: transformNegativeValueToNaN(data.data.results.school.中位數),
          平均: transformNegativeValueToNaN(data.data.results.school.平均),
          下四分位: transformNegativeValueToNaN(
            data.data.results.school["下四分位"]
          ),
          上四分位: transformNegativeValueToNaN(
            data.data.results.school["上四分位"]
          ),
          學生: transformNegativeValueToNaN(data.data.results.school.學生),
        },
      },
    },
  };
}

function transformNegativeValueToNaN(entry: { [dateKey: string]: number }): {
  [dateKey: string]: number;
} {
  return Object.entries(entry).reduce<{ [dateKey: string]: number }>(
    (prev, [curKey, curEntry]) => {
      return {
        ...prev,
        [curKey]: curEntry === -1 ? NaN : curEntry,
      };
    },
    {}
  );
}
